<!-- 
DEPRECATED 
Use Default with dark:true instead
-->
<template>
	<div class="full-page-container t-we">
		<main
			id="content"
			class="page-container"
		>
			<slot />
		</main>
	</div>
</template>

<script setup lang="ts"></script>
